export default {
  chooseFile: 'Choose file',
  uploading: 'Uploading',
  areYouSureToRemoveThisFile: 'Are you sure to remove this file?',
  squareImageError: {
    single: 'Image width and height should be equal',
    multiple:
      'One or more of images width and height is not equal, not uploaded'
  },
  uploadCountLimit:
    'The number of selected files must be less than or equal to {count}',
  file_max_size_exceeded:
    'File max size exceeded for "{fileName}". Upload files smaller than {maxSize} KB.',
  file_extension_not_accepted:
    'File type is not accepted for "{fileName}". Accepted Types are "{accepted}".',
  invalidFileUpload: 'Invalid file selected!',
  nothingSelected: 'Nothing selected',
  confirm: 'Confirm',
  more: 'More ...',
  confirmed: 'Confirmed',
  unconfirmed: 'Unconfirmed',
  uploadImage: 'Upload image',
  updateImage: 'Update image',
  plateIranNumber: 'Iran number',
  plateRightNumber: 'Plate right number',
  plateCharacter: 'Plate character',
  plateLeftNumber: 'Plate left number'
}
